// extracted by mini-css-extract-plugin
export default {"recos":"p6-z","productCardOverride":"q6-z","rowHasBadge":"r6-z"};